import { format } from 'date-fns';
import React from 'react';
import { trpc } from '../../utils/trpc';

const Workers = () => {
  const workers = trpc.worker.workers.useQuery(undefined, { refetchInterval: 5000 });

  return (
    <div className="flex flex-col">
      <div className="flex-row mt-5">
        <div className="flex-grow text-center">
          <p className="text-center text-2xl">Worker Status</p>
        </div>
      </div>
      <div className="m-6" />
      <div className="flex-row">
        <div className="relative overflow-x-auto">
          {!workers.data && <p>Loading</p>}
          {workers.isSuccess && (
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Worker name
                  </th>
                  <th scope="col" className="px-6 py-3">
                    IP
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Birthday
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Job
                  </th>
                </tr>
              </thead>
              <tbody>
                {workers.data &&
                  workers.data.workers.map((worker) => (
                    <tr key={worker.name} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        {worker.name}
                      </th>
                      <td className="px-6 py-4">{worker.ip}</td>
                      <td className="px-6 py-4">{worker.status}</td>
                      <td className="px-6 py-4">{format(worker.birth_date, 'PPpp')}</td>
                      <td className="px-6 py-4">{worker.job?.job_meta?.PRINCIPAL?.email ?? 'N/A'}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default Workers;
